import React, {useEffect} from 'react';
import TextField from "@mui/material/TextField";
import {isValidMobile, numOnKeyDown} from "../../../../../../tools/helper";
import {Box, Grid, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {GetState, SetState} from "../../../../../../redux/reduxhelper";
import {USER_DATA} from "../../../../../../redux/action/type.action";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";
import {loginToAccountApi} from "../../../../../../api/AdminApi";
import {errorMessage} from "../../../../../../tools/messages";

const LoginByOtpStep1 = ({setSlideIndex}) => {
    const navigate = useNavigate();
    const userData = GetState(USER_DATA, {});
    const dispatch = useDispatch();


    return (
        <Grid container sx={{alignItems: 'center', justifyContent: 'center'}}>

            <Box sx={{
                my: 8,
                mx: 4,
                flexDirection: 'column',
                width: {xs: 'null', md: '60%'}
            }}>
                <Grid sx={{textAlign: 'end'}}>
                    <Link onClick={() => setSlideIndex(0)}
                          underline="none" href="#"
                          variant="body2">
                        <KeyboardBackspaceIcon/>
                    </Link>
                </Grid>


                <Grid sx={{textAlign: 'center', mb: 4}}>
                    <Typography>
                        شماره موبایل خود را وارد کنید
                    </Typography>
                </Grid>
                <Box noValidate>

                    <TextField onKeyDown={numOnKeyDown}

                               fullWidth
                               value={userData?.mobile}
                               onChange={(e) => dispatch(SetState(USER_DATA, {...userData, mobile: e?.target?.value}))}
                               type="number"
                               label="شماره موبایل"
                               autoFocus


                    />

                    <Stack justifyContent={'center'} direction={'row'} alignItems={'center'} sx={{width: '100%'}}>
                        <Button
                            onClick={() => {
                                if (!isValidMobile(userData?.mobile)) {
                                    errorMessage('موبایل معتبر نیست');
                                    return false;
                                }
                                setSlideIndex(2)
                            }}

                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                my: 2,
                                padding: '12px',
                                borderRadius: '40px',
                                backgroundColor: '#592EA9',
                                ":hover": {bgcolor: '#5D5FEF'}
                            }}
                        >
                            ارسال رمز یکبار مصرف
                        </Button>
                    </Stack>

                </Box>
            </Box>
        </Grid>

    );
};

export default LoginByOtpStep1;
